export default function Reducer(prevState, action){
    switch (action.type) {
        case "LOADING":
            return {
                ...prevState,
                loading: true,
            };
        case "LOADED": 
            return {
                ...prevState,
                history: action.history,
                loading: false,
            };
        default:
            throw new Error();
    }
}